import { patchObject } from '../app/shared/util/object-util';
import { FormArray, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { FormGroupHelper } from './forms/FormGroupHelper';
import { IGenericBaryFormGroup } from './forms/GenericBaryFormGroup';

export type OfferControls = {
  id: FormControl;
  alias: FormControl;
  name: FormControl;
  description: FormControl;
  flexibilityDeadline: FormControl;
  status: FormControl;
  merchandiseType: FormControl;
  serviceType: FormControl;
  measureUnit: FormControl;
  itemScope: FormControl;
  roundedUpPrice: FormControl;
  pickupAddressFloorNumber: FormControl;
  pickupComments: FormControl;
  pickupPhoneCallAnHourBefore: FormControl;
  pickupFloorUpstairQuotationNeeded: FormControl;
  pickupVatExoneration: FormControl;
  pickupTimeslotStart: FormControl;
  pickupTimeslotStartDefault: FormControl;
  pickupTimeslotEnd: FormControl;
  pickupTimeslotEndDefault: FormControl;
  pickupTimeslotRange: FormControl;
  deliveryAddressFloorNumber: FormControl;
  deliveryComments: FormControl;
  deliveryPhoneCallAnHourBefore: FormControl;
  deliveryFloorUpstairQuotationNeeded: FormControl;
  deliveryVatExoneration: FormControl;
  deliveryTimeslotStart: FormControl;
  deliveryTimeslotStartDefault: FormControl;
  deliveryTimeslotEnd: FormControl;
  deliveryTimeslotEndDefault: FormControl;
  deliveryTimeslotRange: FormControl;
  offerDescriptionItems: FormArray;
  pricingOptions: FormArray;
  roundedPrice: FormControl;
  productCode: FormControl;
  toWeightWeighted: FormControl;
  weightingFactor: FormControl;
  carbonEmissionFactor: FormControl;
  offerVehicles: FormArray;
  isControlledTemperature?: FormControl;
  isHazardousMaterial?: FormControl;
  minTemperatureThreshold?: FormControl;
  maxTemperatureThreshold?: FormControl;
  weightUnit: FormControl;
  insuranceItems: FormArray;
};

export class OfferFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<OfferControls> {
  protected declare readonly form: FormGroup;
  name = 'newShopForm';
  updated = false;
  controls: OfferControls;

  constructor(formName: string, controls: OfferControls, validators?: ValidatorFn[]) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
  }

  value(): any {
    return this.form.value;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: any): void {
    this.form.patchValue(model);
  }

  updateModel(model: any): void {
    patchObject(model, this.form.value);
  }
}
